import JSZip from 'jszip';
import {isTypeOf,fileExtension} from './FileHelpers';
import fileTypes from '../constants/file_types';
import {saveAs} from 'file-saver';

export const EPUB_FILE_INFO = [
  ['flat', 'OEBPS/'],
  ['images', 'OEBPS/images/'],
  ['fonts', 'OEBPS/fonts/'],
  ['audio', 'OEBPS/audio/'],
  ['video', 'OEBPS/video/'],
]

const META_INF = '<?xml version="1.0"?><container version="1.0" xmlns="urn:oasis:names:tc:opendocument:xmlns:container"><rootfiles><rootfile full-path="OEBPS/content.opf" media-type="application/oebps-package+xml"/></rootfiles></container>'

const EXCLUDED_FILES = ['mimetype', 'META-INF']

export default class EpubZipper {
  constructor() {
    this.resetFiles();
  }

  length() {
    let size = 0;
    for (var k in this.files) {
      size += this.files[k].length;
    }
    return size;
  }

  includes(fileName) {
    return EPUB_FILE_INFO.map(pieces => {
      let type = pieces[0];
      return this.files[type].some(f => {
        return f.name === fileName;
      });
    }).some(b => b);
  }

  addFile(file) {
    if(this.permissibleFile(file)) {
      this.addFileWithType(file);
      return true;
    } else {
      return false;
    }
  }

  removeFile(type, index) {
    this.files[type].splice(index, 1);
  }

  resetFiles() {
    this.files = {
      flat: [],
      images: [],
      fonts: [],
      audio: [],
      video: []
    }
  }

  permissibleFile(file) {
    // is an ePub fie we add by default
    if (EXCLUDED_FILES.indexOf(file.name) >= 0) {
      return false;
    // is almost certainly a directory
    } else if (!file.type && file.size%4096 === 0) {
      return false;
    // is a dotfile or already an ePub
    } else if (/.epub$|^\./.test(file.name)) {
      return false;
    } else {
      return true;
    }
  }

  addFileWithType(file) {
    if(isTypeOf('image', file)) {
      this.files.images.push(file)
    } else if (isTypeOf('font', file)) {
      this.files.fonts.push(file)
    } else if (isTypeOf('audio', file)) {
      this.files.audio.push(file)
    } else if (isTypeOf('video', file)) {
      this.files.video.push(file)
    } else {
      this.files.flat.push(file)
    }
  }

  zipFile(zip, file, path) {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.onload = () => {
        zip.file(path + file.name, reader.result);
        resolve();
      };
      reader.readAsArrayBuffer(file);
    });
  }

  zipFileGroup(zip, type, path) {
    let zipFilePromises = this.files[type].map((file) => {
      return this.zipFile(zip, file, path);
    });
    return Promise.all(zipFilePromises);
  }

  zipFiles(zip) {
    let zipFileGroupPromises = EPUB_FILE_INFO.map((fileInfo) => {
      return this.zipFileGroup(zip, fileInfo[0], fileInfo[1]);
    });
    return Promise.all(zipFileGroupPromises);
  }

  finalizeZip(zip, name) {
    return zip.generateAsync({type:"blob"}).then(function (blob) {
      saveAs(blob, name);
    }).catch((err) => {
      if(!/blob.*supported/.test(err.message)) { console.log(err); }
    });
  }

  addStandardFiles(zip) {
    zip.file('mimetype', 'application/epub+zip', {compression: 'STORE'});
    zip.file('META-INF/container.xml', META_INF);
  }

  toEpub(name) {
    let zip = new JSZip();
    this.addStandardFiles(zip);
    return this.zipFiles(zip, name, 0).then(() => {
      return this.finalizeZip(zip, name)
    }).then(() => {
      return zip;
    });
  }
}
